// ─── Sub-categories with preference keys ────────────────────────────
export const EXPLORE_SUBS = [
  { label: "Select All", pref: "all" },
  { label: "Top Attractions", pref: "top attraction" },
  { label: "Hidden Gems", pref: "hidden gems" },
  { label: "Food & Drinks", pref: "food & drinks" },
  { label: "National Parks & Wildlife", pref: "national parks & wildlife" },
  { label: "Hiking Trails", pref: "hiking trails" },
  { label: "Adventure Sports", pref: "adventure sports" },
  { label: "Other", pref: "other" },
];

export const ACCOMMODATION_SUBS = [
  { label: "Select All", pref: "all" },
  { label: "Cabins & Lodges", pref: "cabins & lodges" },
  { label: "Campsites", pref: "campsites" },
  { label: "Unique Stays", pref: "unique stays" },
  { label: "Hotels & Resorts", pref: "hotels & resorts" },
  { label: "Other", pref: "other" },
];

export const TRANSPORT_SUBS = [
  { label: "Select All", pref: "all" },
  { label: "Flights", pref: "flight" },
  { label: "RVs", pref: "rv" },
  // { label: "Rental Cars", pref: "rental_car" },
  // { label: "Train Tickets", pref: "train" },
  // { label: "Bus Tickets", pref: "bus" },
  // { label: "Other", pref: "other" },
];
